// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 4.40414V2H11V4.40379C10.9501 4.3956 10.8997 4.38703 10.8485 4.37813C10.7609 4.36288 10.6686 4.34612 10.5727 4.32871C10.2448 4.26915 9.87526 4.20205 9.50874 4.16222C8.48283 4.05076 7.3545 4.13183 6.01461 4.8757C3.37849 6.33922 2 9.09964 2 12.5C2 16.7816 4.71854 20.7965 8.1874 21.9381C9.22824 22.2807 9.97369 22.0957 10.5938 21.8677C10.6918 21.8317 10.7817 21.7974 10.8659 21.7652C11.2821 21.6063 11.5606 21.5 12 21.5C12.44 21.5 12.7189 21.6063 13.1354 21.765L13.1363 21.7654C13.22 21.7973 13.3093 21.8313 13.4066 21.8671C14.0263 22.0945 14.771 22.2793 15.8113 21.9386C19.2901 20.799 22 16.78 22 12.5C22 9.09944 20.6209 6.33534 17.9845 4.87516C16.6453 4.13345 15.5173 4.05257 14.4918 4.16345C14.1251 4.20311 13.7555 4.26997 13.4274 4.32933C13.3317 4.34665 13.2394 4.36333 13.1519 4.37851C13.1006 4.3874 13.05 4.39596 13 4.40414ZM9 6C9 6 10.8754 6.63618 12 6.63618C13.1247 6.63618 15 6 15 6C15 6 14.2577 8 12 8C9.7424 8 9 6 9 6Z"}}]};

const AppleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'apple-filled',
    ref,
    icon: element,
  },
));

AppleFilledIcon.displayName = 'AppleFilledIcon';

export default AppleFilledIcon;
